import Close from '@mdi/svg/svg/close.svg?react';
import { type OutageStatus } from '@solinkcorp/authentication';
import { MDIIconButton, MinorOutageBanner } from '@solinkcorp/solink-components';
import { useUnmount } from '@solinkcorp/utils/hooks';
import { useCallback, useState } from 'react';
import { getLocally, removeLocally, storeLocally } from 'src/core/utils/StorageAPI';
import useLocale from 'src/hooks/useLocale';
import './MinorOutage.sass';

export const MINOR_OUTAGE_STATUS_KEY = 'MINOR_OUTAGE_STATUS';

function MinorOutage({ outageStatus }: { outageStatus: OutageStatus }) {
  const locale = useLocale();
  const [dismissedOutageStatus, setDismissedOutageStatus] = useState<null | OutageStatus>(() =>
    getLocally<OutageStatus>(MINOR_OUTAGE_STATUS_KEY),
  );

  useUnmount(() => {
    /** Delete cached outage if there's new outage the user did not dismiss */
    if (dismissedOutageStatus?.page?.id !== outageStatus?.page?.id) {
      removeLocally(MINOR_OUTAGE_STATUS_KEY);
    }
  });

  const dismissOutage = useCallback(() => {
    setDismissedOutageStatus(outageStatus);
    storeLocally(MINOR_OUTAGE_STATUS_KEY, outageStatus);
  }, [outageStatus]);

  /** the outage was previously dismissed */
  if (dismissedOutageStatus?.page.id === outageStatus?.page?.id) {
    return null;
  }

  return (
    <div className="minor-outage-wrapper">
      <MinorOutageBanner>
        <>
          <div>
            <span>{locale.outage.minor}</span> &#45;{' '}
            <a href="https://status.solinkcloud.com/" rel="noreferrer" target="_blank">
              https://status.solinkcloud.com
            </a>
          </div>
          <MDIIconButton icon={Close} title="dismiss" onClick={dismissOutage} />
        </>
      </MinorOutageBanner>
    </div>
  );
}

export default MinorOutage;
